<script>
    import { Line, mixins } from 'vue-chartjs';
    const { reactiveProp } = mixins;

    export default {
        extends: VueChartJs.Line,
        mixins: [reactiveProp],
        data(){
            return{
                options: {
                    type: Object,
                    maintainAspectRatio: false,
                }
            }},
        mounted () {
            this.renderChart(this.chartData,  this.options)
        }

    }

    </script>
<style scoped lang="scss" >

    </style>